import { render, staticRenderFns } from "./messageCreate.vue?vue&type=template&id=b4e38658&scoped=true&"
import script from "./messageCreate.vue?vue&type=script&lang=js&"
export * from "./messageCreate.vue?vue&type=script&lang=js&"
import style0 from "./messageCreate.vue?vue&type=style&index=0&id=b4e38658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e38658",
  null
  
)

export default component.exports